import BarChartIcon from "@mui/icons-material/BarChart";
import DonutLargeIcon from "@mui/icons-material/DonutLarge";
import ViewAgendaIcon from "@mui/icons-material/ViewAgenda";
import { BlockCard, SegmentedPills } from "../primitives";
import type { PillOption } from "../primitives";
import { BlockBaseProps } from "../types";
import FunnelBars from "./FunnelBars";
import FunnelColumns from "./FunnelColumns";
import FunnelRings from "./FunnelRings";
import ActivationFunnelBlockSkeleton from "./Skeleton";
import styles from "./style.module.scss";
import { FunnelStage, FunnelView } from "./types";

const VIEWS: PillOption<FunnelView>[] = [
  { key: "bars", title: "Bars", icon: <ViewAgendaIcon /> },
  { key: "rings", title: "Rings", icon: <DonutLargeIcon /> },
  { key: "cols", title: "Columns", icon: <BarChartIcon /> },
];

interface ActivationFunnelBlockProps extends BlockBaseProps {
  stages: FunnelStage[];
  view?: FunnelView;
  onViewChange?: (view: FunnelView) => void;
  title?: string;
  format?: (value: number) => string;
}

/**
 * Seats bought to children reading, in three interchangeable views.
 * The view is controlled, so the page can persist the reader's choice.
 */
function ActivationFunnelBlock({
  stages,
  view = "bars",
  onViewChange,
  title = "Activation funnel",
  format,
  loading,
  empty,
  className,
}: ActivationFunnelBlockProps) {
  if (loading) {
    return (
      <ActivationFunnelBlockSkeleton
        view={view}
        count={stages.length || 4}
        className={className}
      />
    );
  }

  return (
    <BlockCard
      empty={empty}
      title={title}
      headerTight
      headerClassName={styles.header}
      className={className}
      actions={
        onViewChange && (
          <SegmentedPills
            options={VIEWS}
            value={view}
            onChange={onViewChange}
            shape="square"
          />
        )
      }
    >
      {view === "bars" && <FunnelBars stages={stages} format={format} />}
      {view === "rings" && <FunnelRings stages={stages} format={format} />}
      {view === "cols" && <FunnelColumns stages={stages} format={format} />}
    </BlockCard>
  );
}

export default ActivationFunnelBlock;
